import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Hoş geldiniz");
      nav("/admin");
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Giriş başarısız");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-brand flex items-center justify-center px-6">
      <form onSubmit={submit} className="paper-card w-full max-w-md p-10" data-testid="admin-login-form">
        <div className="eyebrow mb-2">Yönetim</div>
        <h1 className="font-serif-elegant text-4xl mb-8 text-primary-brand">BiGeldi Studio</h1>
        <label className="block mb-4">
          <div className="text-xs tracking-luxury uppercase text-secondary-brand mb-2">E-posta</div>
          <input type="email" required value={email} onChange={e=>setEmail(e.target.value)}
            className="w-full bg-transparent border-b border-brand py-2 outline-none focus:border-accent-brand transition"
            data-testid="admin-login-email" />
        </label>
        <label className="block mb-8">
          <div className="text-xs tracking-luxury uppercase text-secondary-brand mb-2">Şifre</div>
          <input type="password" required value={password} onChange={e=>setPassword(e.target.value)}
            className="w-full bg-transparent border-b border-brand py-2 outline-none focus:border-accent-brand transition"
            data-testid="admin-login-password" />
        </label>
        <button className="btn-primary w-full justify-center" disabled={busy} data-testid="admin-login-submit">
          {busy ? "Giriş yapılıyor..." : "Giriş Yap"}
        </button>
      </form>
    </div>
  );
}
